import { Card, Stack, Title, Code, Group, Button } from '@repletoryreach/sdk-ui';
import { notifySuccess, notifyError } from '@repletoryreach/sdk-ui/notifications';
import { useT } from '../../../../i18n/I18nProvider';

export function TemplateBody({ components }: { components: string }) {
  const t = useT();
  let pretty = components;
  try {
    pretty = JSON.stringify(JSON.parse(components), null, 2);
  } catch {
    // Keep the raw value: an unparseable payload is exactly what this tab is
    // for, and reformatting is not worth losing the original bytes.
  }

  async function copy() {
    try {
      await navigator.clipboard.writeText(pretty);
      notifySuccess(t('templates.view.components.copied'), t('templates.view.variables.toast.copiedTitle'));
    } catch {
      notifyError(t('templates.view.variables.toast.copyFailed'));
    }
  }

  return (
    <Card withBorder>
      <Stack gap="md">
        <Group justify="space-between" align="baseline">
          <Title order={4}>{t('templates.view.components.title')}</Title>
          <Button size="xs" variant="outline" onClick={() => void copy()}>{t('action.copy')}</Button>
        </Group>
        <Code block>{pretty}</Code>
      </Stack>
    </Card>
  );
}
